import {useHistory, useQueryParams} from '@aboutyou/router';
import React, {FC, useEffect, useRef} from 'react';
import {INVALIDATE_CAMPAIGN_PARAM} from './constants';

export const CampaignReload: FC<{
  campaignId?: string;
}> = ({campaignId}) => {
  const queryParams = useQueryParams();
  const invalidateCampaignParam = useRef(
    queryParams.get(INVALIDATE_CAMPAIGN_PARAM),
  ).current;

  if (invalidateCampaignParam) return null; // already reloaded

  return <ReloadPage campaignId={campaignId} />;
};

const ReloadPage: FC<{
  campaignId?: string;
}> = ({campaignId}) => {
  const history = useHistory();

  useEffect(() => {
    const nextSearch = new URLSearchParams(history.location.search);

    nextSearch.set(
      INVALIDATE_CAMPAIGN_PARAM,
      campaignId || Date.now().toString(),
    );

    const finalUrl = `${history.location.pathname}?${nextSearch.toString()}`;

    window.location.href = finalUrl;
  }, [campaignId, history.location.pathname, history.location.search]);

  return null;
};
